/**
 * How money is said everywhere (Miles, 2026-10-23): plain figures, no "owes you" sentences.
 * A person's balance is a signed figure from their side (minus and red they owe, plus and green a
 * credit). A total across people is a short label and a figure. Empty hides a label.
 */

// ---- totals across people (Overview, People, a group's People) and their headings
export const TOTAL_OWED_LABEL = "Owed to you";
export const TOTAL_OWE_LABEL = "You owe";
/** The line under a page title ({owed} and {owe} are the figures above's labels and amounts). */
export const TOTALS_LINE = "{owedLabel} {owed} · {oweLabel} {owe}";
/** When nothing is owed either way. */
export const TOTALS_SQUARE = "All square";
/** The Overview's lists and chart. */
export const PANEL_OWED_TITLE = "Owed to you";
export const PANEL_OWE_TITLE = "You owe";
export const CHART_OWED_TITLE = "Owed to you over time";
/** A member's own chart on a group's Overview. */
export const CHART_MINE_TITLE = "Your balance over time";

// ---- a group's card on the Overview ({count} = people)
export const GROUP_CARD_PEOPLE_ONE = "{count} person owes";
export const GROUP_CARD_PEOPLE_MANY = "{count} people owe";
export const GROUP_CARD_SQUARE = "All square";

// ---- your own pages (a member's Overview, a family's or tutor's Tutoring page)
/** The label beside your balance; the figure says which way (minus: you owe). */
export const MY_BALANCE_LABEL = "Your balance";
/** A line of your balance by where it's from ({label} = group name or Tutoring). */
export const MY_SOURCE_GROUP_TAG = "Group";
export const MY_SOURCE_TUTORING_TAG = "Tutoring";
